import React from 'react';
import {IntlProvider} from 'react-intl';
import en from '../../i18n/en.json';
import he from '../../i18n/he.json';

export interface IntlProviderProps {
  children: React.ReactNode;
}

const messages = {en, he};

/** Should be child of the store provider */
const I18nProvider = ({children}: IntlProviderProps) => {
  const currentLocale = process.env.NODE_ENV === 'development' ? 'en' : 'he';

  return (
    <IntlProvider
      locale={currentLocale}
      messages={messages[currentLocale]}
    >
      {children}
    </IntlProvider>
  );
};

export default I18nProvider;
